import { useMemo } from "react";

import { getFirstDateOfYear, getLastDateOfYear } from "../utils";

function useSeasonYears({ mlsSeasons = new Map() }) {
    const { seasonFirstYear, seasonLastYear } = useMemo(() => {
        const seasonsOrdered = Array.from(mlsSeasons.values()).sort((a, b) => a.season - b.season);
        const seasonFirstYear = seasonsOrdered[0]?.season;
        const seasonLastYear = seasonsOrdered[seasonsOrdered.length - 1]?.season;

        return {
            seasonFirstYear: getFirstDateOfYear(seasonFirstYear),
            seasonLastYear: getLastDateOfYear(seasonLastYear)
        }
    }, [mlsSeasons]);

    return {
        seasonFirstYear,
        seasonLastYear
    }
}

export default useSeasonYears;